import { DebouncedFunc } from "lodash-es"
import throttle from "lodash-es/throttle"

type productBlockProps = {
  panelsSelector: string
}

export default function productBlock(
  el: HTMLElement,
  props: productBlockProps,
) {
  const panelEls: NodeListOf<HTMLElement> = el.querySelectorAll(
    props.panelsSelector,
  )
  if (panelEls == null) {
    return
  }
  const mediaQuery = window.matchMedia("(min-width: 1200px)")

  let handler: DebouncedFunc<any>

  function checkMedia() {
    if (mediaQuery.matches) {
      handler = throttle(function () {
        init(panelEls)
      }, 10)
      document.addEventListener("scroll", handler)
      document.addEventListener("resize", handler)
    } else {
      document.removeEventListener("scroll", handler)
      document.removeEventListener("resize", handler)
      destroy(panelEls)
    }
  }
  mediaQuery.addEventListener("change", checkMedia)
  checkMedia()
}

function init(panelEls: NodeListOf<HTMLElement>) {
  affixAndTransitionPanels(panelEls)
}

function destroy(panelEls: NodeListOf<HTMLElement>) {
  panelEls.forEach(el => {
    let firstChild: HTMLElement | null = el.firstChild as HTMLElement
    if (firstChild == null) {
      return
    }
    el.removeAttribute("style")
    firstChild.removeAttribute("style")
    el.classList.remove("opacity-100", "opacity-0", "visible", "invisible")
  })
}

function affixAndTransitionPanels(panelEls: NodeListOf<HTMLElement>) {
  let firstPanelBounds = panelEls[0].getBoundingClientRect()
  let secondPanelBounds = panelEls[1].getBoundingClientRect()
  let lastPanelBounds = panelEls[panelEls.length - 1].getBoundingClientRect()
  let offset = 150
  let aspectRatio = 0.74674384949
  panelEls.forEach((el: HTMLElement, index: number) => {
    let firstChild: HTMLElement | null = el.firstChild as HTMLElement
    if (!firstChild) {
      return
    }
    el.style.height = Math.round(el.offsetWidth * aspectRatio) + "px"
    firstChild.style.width = el.offsetWidth + "px"
    firstChild.style.height = Math.round(el.offsetWidth * aspectRatio) + "px"
    if (firstPanelBounds.top < offset && lastPanelBounds.top >= offset) {
      firstChild.style.position = "fixed"
      firstChild.style.top = offset + "px"
    } else {
      firstChild.removeAttribute("style")
    }
    if (
      Math.round(firstPanelBounds.top) < offset * 1.5 * -1 &&
      Math.round(secondPanelBounds.top) >= offset * 1.5 * -1
    ) {
      // Second panel is active
      if (index === 1) {
        revealPanel(el)
      } else {
        hidePanel(el)
      }
    } else if (Math.round(secondPanelBounds.top) < offset * 1.5 * -1) {
      // Third panel is active
      if (index === 2) {
        revealPanel(el)
      } else {
        hidePanel(el)
      }
    } else {
      // First panel is active
      if (index === 0) {
        revealPanel(el)
      } else {
        hidePanel(el)
      }
    }
  })
}

function revealPanel(el: HTMLElement) {
  el.classList.add("opacity-100", "visible")
  el.classList.remove("opacity-0", "invisible")
}

function hidePanel(el: HTMLElement) {
  el.classList.add("opacity-0", "invisible")
  el.classList.remove("opacity-100", "visible")
}
